module.exports = __webpack_public_path__ + "img/news013.0ac866fb.jpg";